module.exports = {
    inputDefault: {},
    inputCheckbox: {},
    toastMessage: {},
};
